import React from 'react';
import { connect } from 'react-redux';
import FindWorks from '../find_works/find_works';
import {
  loadNextFavoritePage
} from '../../actions/works';
import { closePanel } from '../../actions/panel';
import { addToCanvas } from '../../actions/canvas';
import { showMoreLikeThis } from '../../actions/more_like_this';

const mapStateToProps = ({ favoriteWorks, pin }) => ({ ...favoriteWorks, ...pin });

const FindFavoriteWorks = (props) => <FindWorks { ...props } onlyFavorites />;

export default connect(mapStateToProps, {
  loadNextPage: loadNextFavoritePage,
  addToCanvas,
  closePanel,
  showMoreLikeThis
})(FindFavoriteWorks);
